export default {
      id: "ic-soc-threads-usage",
      viewBox: "0 0 26 26",
      url: "../dist/images/" + "sprite.svg#ic-soc-threads-usage",
      toString: function () {
        return this.url;
      }
    }